export function warn(...args: any[]) {
  console.warn(...args)
}
